import { useAuth } from '@/store/auth';
import { ReactNode, Suspense, lazy } from 'react';
import { useShallow } from 'zustand/shallow';

const Eruda = lazy(() =>
  import('./eruda-provider').then((c) => ({ default: c.Eruda }))
);

export const ErudaProvider = (props: { children: ReactNode }) => {
  const [address] = useAuth(useShallow((state) => [state.address]));
 
  // Test production environment
  if (
    import.meta.env.MODE === 'staging' ||
    address?.toLowerCase() ===
      '0xb72df5f5c9982870fdbe46d7c228d73f6d84c032'.toLowerCase()
  ) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Eruda>{props.children}</Eruda>
      </Suspense>
    );
  }

  return props.children;
};
